import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../../common/store/generic.effects';
import {
  KnownIpAddressAction,
  knownIpAddressActions,
} from './known-ip-address.actions';
import { KnownIpAddressApiService } from './known-ip-address.api.service';

@Injectable()
export class KnownIpAddressEffects {
  constructor(
    private readonly knownIpAddressApiService: KnownIpAddressApiService,
    private readonly action$: Actions<KnownIpAddressAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    knownIpAddressActions.getById,
    this.knownIpAddressApiService.getById,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    knownIpAddressActions.update,
    this.knownIpAddressApiService.update,
  );
}
